/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListMaterialsParams,
  PaginatedItems,
  PaginatedMaterials,
  SchemaValidationErrorResponse,
  SearchMaterialsParams,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Materials
 */
export const listMaterials = (
    params?: MaybeRefOrGetter<ListMaterialsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedMaterials>(
      {url: `/materials`, method: 'GET',
        params, signal
    },
      );
    }




export const getListMaterialsQueryKey = (params?: MaybeRefOrGetter<ListMaterialsParams>,) => {
    return [
    'materials', ...(params ? [params] : [])
    ] as const;
    }


export const getListMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listMaterials>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMaterialsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMaterials>>> = ({ signal }) => listMaterials(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>
}

export type ListMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listMaterials>>>
export type ListMaterialsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of Materials
 */

export function useListMaterials<TData = Awaited<ReturnType<typeof listMaterials>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search Materials
 */
export const searchMaterials = (
    params: MaybeRefOrGetter<SearchMaterialsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedItems>(
      {url: `/materials/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchMaterialsQueryKey = (params?: MaybeRefOrGetter<SearchMaterialsParams>,) => {
    return [
    'materials','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof searchMaterials>>, TError = ErrorType<StandardError>>(params: MaybeRefOrGetter<SearchMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchMaterialsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchMaterials>>> = ({ signal }) => searchMaterials(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchMaterials>>, TError, TData>
}

export type SearchMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof searchMaterials>>>
export type SearchMaterialsQueryError = ErrorType<StandardError>


/**
 * @summary Search Materials
 */

export function useSearchMaterials<TData = Awaited<ReturnType<typeof searchMaterials>>, TError = ErrorType<StandardError>>(
 params: MaybeRefOrGetter<SearchMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchMaterials>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






